/**
 * useRecentlyCaught - Recently caught garments for idle state
 *
 * Fetches up to 15 most recently caught garments at the current location.
 * Same query config pattern as print station's useRecentlyPrinted.
 */
import { trpc } from '@/lib/trpc';
import { skipToken } from '@tanstack/react-query';

export function useRecentlyCaught(locationId: string | null) {
  return trpc.catcher.getRecentlyCaught.useQuery(
    locationId ? { locationId } : skipToken,
    {
      staleTime: 15_000,
      refetchInterval: 30_000,
      refetchIntervalInBackground: false,
      refetchOnWindowFocus: true,
    }
  );
}
